export default __webpack_public_path__ + "static/media/_소슬러시_ 데일리 컬러 노트 핑크 (모눈).b1005981.png";